/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileXblr = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h10.414L18 7.586V10h-2V9h-5V4H4v16h12v-1h2v3H2zm11 3.414V7h1.586z" />
        <path d="m4.806 17 1.501-2.526L4.88 12.13h1.2l1.004 1.682.979-1.682h1.152l-1.434 2.365L9.29 17h-1.2l-1.085-1.843L5.96 17zm5.016 0v-4.87h1.708c.621 0 1.077.104 1.367.314.295.21.442.536.442.978 0 .22-.058.416-.174.59s-.277.313-.482.415c.576.179.864.56.864 1.146 0 .951-.659 1.427-1.977 1.427zm1.005-2.854h.509c.353 0 .6-.045.743-.134.148-.094.222-.25.222-.47 0-.227-.072-.386-.215-.475-.143-.094-.393-.14-.75-.14h-.51zm0 2.05h.663c.344 0 .596-.054.757-.16s.241-.276.241-.503c0-.224-.08-.387-.241-.49s-.413-.153-.757-.153h-.663zm3.372.804v-4.87h1.87c.58 0 1.027.133 1.34.401.312.268.468.648.468 1.14 0 .343-.09.636-.268.877a1.416 1.416 0 0 1-.744.516L18.085 17h-1.153l-1.031-1.749-.664-.167V17zm1.038-2.6h.51c.406 0 .687-.051.844-.154.16-.107.24-.292.24-.556s-.08-.447-.24-.55c-.157-.106-.438-.16-.844-.16h-.51zm3.378 2.6v-4.87h1.046v3.939h2.144V17z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileXblr as FileXblr };
